module.exports = __webpack_public_path__ + "static/img/sy_4.3f254ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/sy_4.png
// module id = C9JF
// module chunks = 1